export const enum PatientManagementWizardDetailedPatientInformationKeys {
  PatientId = 'patientId',
  FirstName = 'firstName',
  LastName = 'lastName',
  DateOfBirth = 'dateOfBirthIso8601',
  PhoneNumber = 'phone',
  CareGiver = 'mainCareGiver',
  AvailableCareGivers = 'careGivers',
  InhalerType = 'inhalerType',
  Program = 'programId',
  VibePackage = 'vibePackage',
  AvailableVibes = 'availableVibes',
}
export const allPatientManagementWizardDetailedPatientInformationKeys = [
  PatientManagementWizardDetailedPatientInformationKeys.FirstName,
  PatientManagementWizardDetailedPatientInformationKeys.LastName,
  PatientManagementWizardDetailedPatientInformationKeys.PhoneNumber,
  PatientManagementWizardDetailedPatientInformationKeys.CareGiver,
  PatientManagementWizardDetailedPatientInformationKeys.DateOfBirth,
  PatientManagementWizardDetailedPatientInformationKeys.InhalerType,
  PatientManagementWizardDetailedPatientInformationKeys.Program,
  PatientManagementWizardDetailedPatientInformationKeys.AvailableCareGivers,
  PatientManagementWizardDetailedPatientInformationKeys.VibePackage,
  PatientManagementWizardDetailedPatientInformationKeys.AvailableVibes,
]

export const enum SimplePatientInformationKeys {
  PatientId = 'id',
  FirstName = 'firstName',
  LastName = 'lastName',
  PhoneNumber = 'phoneNumber',
  // InhalerType = 'inhalerType',
  // Program = 'programId',
}

export function getSimpleAttrFromDetailedAttr(simplePatient, attr) {
  let key = null
  switch (attr) {
    case PatientManagementWizardDetailedPatientInformationKeys.PatientId:
      key = SimplePatientInformationKeys.PatientId
      break
    case PatientManagementWizardDetailedPatientInformationKeys.FirstName:
      key = SimplePatientInformationKeys.FirstName
      break
    case PatientManagementWizardDetailedPatientInformationKeys.LastName:
      key = SimplePatientInformationKeys.LastName
      break
    case PatientManagementWizardDetailedPatientInformationKeys.PhoneNumber:
      key = SimplePatientInformationKeys.PhoneNumber
      break
    case PatientManagementWizardDetailedPatientInformationKeys.AvailableCareGivers:
      return [] // not in simple patient
    case PatientManagementWizardDetailedPatientInformationKeys.DateOfBirth:
      return '' // not in simple patient
    default:
      return null // no support for this one
  }
  return simplePatient && simplePatient[key]
}

export const enum VibePackageDeviceTypes {
  Vibe = 'vibe', // vibe ID
  Gateway = 'gateway', // gateway ID
  Tracker = 'tracker',
  Inhaler = 'inhaler',
  PulseOximeter = 'pulseOximeter',
  Scale = 'scale',
  Thermometer = 'thermometer',
  Bpm = 'bpm',
  Glucometer = 'glucometer',
}
export const allPackageDeviceTypes = [
  VibePackageDeviceTypes.Vibe,
  VibePackageDeviceTypes.Gateway,
  VibePackageDeviceTypes.Tracker,
  VibePackageDeviceTypes.Inhaler,
  VibePackageDeviceTypes.PulseOximeter,
  VibePackageDeviceTypes.Scale,
  VibePackageDeviceTypes.Thermometer,
  VibePackageDeviceTypes.Bpm,
  VibePackageDeviceTypes.Glucometer,
]
